import React, { useEffect, useState } from 'react';
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import axios from 'axios';
import { host, url } from '../../../config/common';
import Loader from '../../utils/loader';
import OnsiteFoodCard from '../../utils/onsiteFoodCard';
import CustomPagination from './pagination/customPagination';
import { useNavigate } from 'react-router-dom';

const OnsiteFood = () => {
    const [searchInput, setSearchInput] = useState("");
    const [foodData, setFoodData] = useState({
        list: [],
        loading: false,
        currentPage: "1",
        totalPages: 1,
        totalRecords: 1,
    });
    const [foodParams, setFoodParams] = useState({
        page: 1,
        limit: 21,
    });
    const [showloader, setShowloader] = useState(false);
    let navigate = useNavigate();

    const fetchOnsiteFood = async () => {
        try {
            setShowloader(true)
            let fetchedFoodData = await axios({
                method: 'get',
                headers: { 'x-access-token': JSON.parse(localStorage.getItem('user'))?.token ? JSON.parse(localStorage.getItem('user')).token : "" },
                url: `${host}${url.getShareAnUpdate}?search=${searchInput}&page=${foodParams.page}&limit=${foodParams.limit}&eventName=onsite_food`
            });
            if (fetchedFoodData?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/");
            }
            if (fetchedFoodData) {
                setShowloader(false);
                setFoodData((v) => ({
                    ...v,
                    list: fetchedFoodData?.data?.data?.records,
                    loading: false,
                    currentPage: fetchedFoodData?.data?.data?.currentPage,
                    totalPages: fetchedFoodData?.data?.data?.totalPages,
                    totalRecords: fetchedFoodData?.data?.data?.totalRecords,
                }));
            }
        } catch (error) {
            console.log({ error });
            if (error?.response?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
        }
    }

    const searchOnsiteFood = async (e) => {
        try {
            setFoodParams((v) => ({ ...v, page: 1 }));
            fetchOnsiteFood();
        } catch (error) {
            console.log({ error });
        }
    }

    const handlePageChange = (e, page) => {
        setFoodParams((v) => ({ ...v, page: page }));
    };

    const paginationProps = {
        currentPage: foodData?.currentPage,
        totalPages: foodData?.totalPages,
        totalRecords: foodData?.totalRecords,
        handlePageChange,
    };

    useEffect(() => {
        fetchOnsiteFood();
    }, [foodParams]);

    return (
        <div style={{ padding: "0px 20px" }}>
            <Row>
                <Col>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h3>Onsite Food Requests</h3>
                    </div>
                </Col>
            </Row>
            <Row>
                <div>
                    <Row>
                        <Col xs="7">
                            <Form onSubmit={(e) => { e.preventDefault(); searchOnsiteFood() }}>
                                <InputGroup style={{ width: "500px", float: "left", marginBottom: "1%" }}>
                                    <FormControl
                                        placeholder="Search by restaurant name"
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        value={searchInput}
                                    />
                                    <Button variant="outline-primary" type='submit'>
                                        Search
                                    </Button>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Loader show={showloader} />
                    <Row style={{ height: "82vh", overflow: "scroll " }}>
                        <Col>
                            {foodData?.list?.length > 0
                                ?
                                <>
                                    <Row style={{ marginTop: "20px" }}>
                                        {
                                            foodData?.list?.map((item) =>
                                                <Col sm="4" key={item._id}>
                                                    <OnsiteFoodCard foodData={item} refreshData={() => fetchOnsiteFood()} />
                                                </Col>
                                            )
                                        }
                                    </Row>
                                    <CustomPagination props={{ paginationProps }} />
                                </>
                                :
                                <Row style={{ marginTop: "20px" }}>No Records Found</Row>
                            }

                        </Col>
                    </Row>
                </div>
            </Row>
        </div>
    );
}

export default OnsiteFood;
